/* eslint-disable */
import React from 'react';

export const Icon = ({ name, className = 'icon', ...rest }) => {
  const paths = {
    search: <><circle cx="11" cy="11" r="7" /><path d="m20 20-3.5-3.5" /></>,
    user: <><circle cx="12" cy="8" r="4" /><path d="M4 21c0-4.4 3.6-8 8-8s8 3.6 8 8" /></>,
    bag: <><path d="M5 7h14l-1.5 13a2 2 0 0 1-2 1.8H8.5A2 2 0 0 1 6.5 20L5 7z" /><path d="M9 7V5a3 3 0 0 1 6 0v2" /></>,
    heart: <path d="M12 20s-7-4.5-9.3-9.2C1.2 7.4 3.6 4 7 4c1.9 0 3.6 1 5 2.6C13.4 5 15.1 4 17 4c3.4 0 5.8 3.4 4.3 6.8C19 15.5 12 20 12 20z" />,
    heartFill: <path d="M12 20s-7-4.5-9.3-9.2C1.2 7.4 3.6 4 7 4c1.9 0 3.6 1 5 2.6C13.4 5 15.1 4 17 4c3.4 0 5.8 3.4 4.3 6.8C19 15.5 12 20 12 20z" fill="currentColor" />,
    arrow: <><path d="M5 12h14" /><path d="m13 5 7 7-7 7" /></>,
    arrowSm: <><path d="M5 12h12" /><path d="m11 6 6 6-6 6" /></>,
    chev: <path d="m9 6 6 6-6 6" />,
    chevDown: <path d="m6 9 6 6 6-6" />,
    check: <path d="m4 12 5 5L20 6" />,
    plus: <><path d="M12 5v14" /><path d="M5 12h14" /></>,
    minus: <path d="M5 12h14" />,
    close: <><path d="M6 6l12 12" /><path d="M18 6 6 18" /></>,
    menu: <><path d="M4 7h16" /><path d="M4 12h16" /><path d="M4 17h16" /></>,
    home: <><path d="M3 11 12 3l9 8" /><path d="M5 10v10h14V10" /></>,
    truck: <><path d="M3 7h11v9H3z" /><path d="M14 10h4l3 3v3h-7" /><circle cx="7" cy="18" r="2" /><circle cx="17" cy="18" r="2" /></>,
    leaf: <><path d="M5 19c0-9 7-15 16-15-1 9-7 15-16 15z" /><path d="M5 19s4-7 12-11" /></>,
    pin: <><path d="M12 22s7-7 7-12a7 7 0 1 0-14 0c0 5 7 12 7 12z" /><circle cx="12" cy="10" r="3" /></>,
    clock: <><circle cx="12" cy="12" r="9" /><path d="M12 7v5l3 2" /></>,
    mail: <><rect x="3" y="5" width="18" height="14" rx="1" /><path d="m3 7 9 6 9-6" /></>,
    grid: <><rect x="4" y="4" width="7" height="7" /><rect x="13" y="4" width="7" height="7" /><rect x="4" y="13" width="7" height="7" /><rect x="13" y="13" width="7" height="7" /></>,
    sliders: <><path d="M4 6h12" /><path d="M20 6h0" /><path d="M4 12h4" /><path d="M12 12h8" /><path d="M4 18h12" /><path d="M20 18h0" /><circle cx="18" cy="6" r="2" /><circle cx="10" cy="12" r="2" /><circle cx="18" cy="18" r="2" /></>,
    star: <path d="M12 3l2.7 5.6 6.3.9-4.5 4.4 1 6.1L12 17l-5.5 3 1-6.1L3 9.5l6.3-.9z" fill="currentColor" stroke="none" />,
    starOutline: <path d="M12 3l2.7 5.6 6.3.9-4.5 4.4 1 6.1L12 17l-5.5 3 1-6.1L3 9.5l6.3-.9z" />,
    lock: <><rect x="5" y="11" width="14" height="10" rx="1" /><path d="M8 11V7a4 4 0 1 1 8 0v4" /></>,
    book: <><path d="M4 4h7a3 3 0 0 1 3 3v14" /><path d="M20 4h-3a3 3 0 0 0-3 3v14" /><path d="M4 4v17h16V4" /></>,
  };
  return <svg className={className} viewBox="0 0 24 24" {...rest}>{paths[name]}</svg>;
};

export const Stars = ({ n = 5, total = 5, className = 'bw-stars' }) => (
  <span className={className}>
    {Array.from({ length: total }).map((_, i) => i < Math.round(n) ? '★' : '☆').join('')}
  </span>
);

export const StripePlaceholder = ({ label, className = '' }) => (
  <div className={`bw-card-img-stripe ${className}`}>
    <div className="bw-card-img-label">{label || 'PRODUCT IMAGE'}</div>
  </div>
);

export const Intensity = ({ value, max = 12, compact = false }) => (
  <div className="bw-intensity">
    {!compact && <span>Intensity</span>}
    <span className="bw-intensity-bars">
      {Array.from({ length: max }).map((_, i) => (
        <span key={i} className={`bw-intensity-bar ${i < value ? 'is-on' : ''}`} />
      ))}
    </span>
    <span>{value}/{max}</span>
  </div>
);

export const ColorSwatches = ({ colors, selected, onSelect, large = false }) => {
  if (!colors) return null;
  if (large) return (
    <div className="bw-pdp-swatches">
      {colors.map(c => (
        <button key={c.name} className={`bw-pdp-swatch ${selected === c.name ? 'is-active' : ''}`} onClick={() => onSelect(c.name)}>
          <span className="bw-pdp-swatch-dot" style={{ background: c.hex }}></span>
          <span>{c.name}</span>
        </button>
      ))}
    </div>
  );
  return (
    <div className="bw-color-swatches">
      {colors.map(c => (
        <span key={c.name} className={`bw-color-swatch ${selected === c.name ? 'is-active' : ''}`} style={{ background: c.hex }} title={c.name} onClick={(e) => { e.stopPropagation(); onSelect && onSelect(c.name); }} />
      ))}
    </div>
  );
};

// ProductCard — image now carries a hover "quick add" pill (desktop) in
// addition to the persistent Add to Cart button below (always shown on
// touch devices, hidden via CSS on hover-capable pointers so it's not
// duplicated). Badge and wishlist heart markup unchanged; the new dark
// wax-stamp / blurred-heart look comes entirely from BrewedShop.css.
export const ProductCard = ({ p, onOpen, wished, onWish, onAdd }) => {
  const [color, setColor] = React.useState(p.colors ? p.colors[0].name : null);
  const handleWish = (e) => { e.stopPropagation(); onWish(p.id); };
  const handleAdd = (e) => { e.stopPropagation(); onAdd(p); };
  return (
    <div className="bw-card" onClick={() => onOpen(p)}>
      <div className="bw-card-img">
        {p.image
          ? <img src={p.image} alt={p.name} style={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block' }} />
          : <StripePlaceholder label={`${p.name}${color ? ' · ' + color : ''}`} />
        }
        {p.tag && <span className={`bw-card-tag ${p.tag === 'Sale' || p.tag === 'Limited' ? 'bw-card-tag--accent' : ''}`}>{p.tag}</span>}
        <button className={`bw-card-wish ${wished ? 'is-active' : ''}`} onClick={handleWish} aria-label="Wishlist">
          <Icon name={wished ? 'heartFill' : 'heart'} className="icon icon--sm" />
        </button>
        {p.stock && (
          <button className="bw-card-quickadd" onClick={handleAdd}>+ Quick add</button>
        )}
      </div>
      <div className="bw-card-info">
        <span className="bw-card-origin">{p.origin}</span>
        <span className="bw-card-name">{p.name}</span>
        {p.notes && <span className="bw-card-tasting">{p.notes}</span>}
        {p.intensity && (
          <div style={{ marginTop: 4 }}>
            <Intensity value={p.intensity} compact />
          </div>
        )}
        {p.colors && (
          <div style={{ marginTop: 6 }}>
            <ColorSwatches colors={p.colors} selected={color} onSelect={setColor} />
          </div>
        )}
        <div className="bw-card-meta" style={{ marginTop: 4 }}>
          <span className="bw-card-price">${p.price}</span>
          <span style={{ display: 'inline-flex', alignItems: 'center', gap: 4, fontSize: 11, color: 'var(--ink-muted)' }}>
            <span style={{ color: 'var(--accent)' }}>★</span>
            {p.rating.toFixed(1)} <span style={{ opacity: 0.6 }}>({p.reviews})</span>
          </span>
        </div>
        <div className="bw-card-addwrap" style={{ marginTop: 6 }}>
          {p.stock ? (
            <button className="bw-btn bw-btn--ghost bw-btn--small bw-btn--block" onClick={handleAdd}>Add to Cart</button>
          ) : (
            <span className="mono" style={{ color: 'var(--ink-faint)' }}>Sold out</span>
          )}
        </div>
      </div>
    </div>
  );
};

export const SearchModal = ({ data, onClose, onOpen }) => {
  const [q, setQ] = React.useState('');
  const ref = React.useRef(null);
  React.useEffect(() => { ref.current && ref.current.focus(); }, []);
  React.useEffect(() => {
    const onKey = (e) => { if (e.key === 'Escape') onClose(); };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [onClose]);

  const lq = q.trim().toLowerCase();
  const results = lq.length === 0 ? [] : data.products.filter(p =>
    p.name.toLowerCase().includes(lq) ||
    (p.origin || '').toLowerCase().includes(lq) ||
    (p.notes || '').toLowerCase().includes(lq) ||
    (p.type || '').toLowerCase().includes(lq) ||
    (p.roast || '').toLowerCase().includes(lq)
  ).slice(0, 8);

  const popular = data.products.filter(p => p.tag === 'Bestseller').slice(0, 4);
  const articles = lq.length === 0 ? [] : (data.articles || []).filter(a =>
    a.title.toLowerCase().includes(lq) || a.excerpt.toLowerCase().includes(lq) || a.tag.toLowerCase().includes(lq)
  ).slice(0, 3);

  const pickProduct = (p) => { onOpen(p); onClose(); };

  return (
    <div className="bw-search-overlay" onClick={onClose}>
      <div className="bw-search-panel" onClick={(e) => e.stopPropagation()}>
        <div className="bw-search-input-wrap">
          <Icon name="search" />
          <input ref={ref} className="bw-search-input" value={q} onChange={(e) => setQ(e.target.value)} placeholder="Search coffee, machines, recipes…" />
          <button className="bw-search-close" onClick={onClose}>Esc</button>
        </div>
        <div className="bw-search-results">
          {lq.length === 0 && (
            <>
              <div className="bw-search-section-label">Popular</div>
              {popular.map(p => (
                <div key={p.id} className="bw-search-result" onClick={() => pickProduct(p)}>
                  <div className="bw-search-result-img">
                    {p.image
                      ? <img src={p.image} alt={p.name} style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                      : <div className="bw-search-result-img-stripe"></div>
                    }
                  </div>
                  <div className="bw-search-result-info">
                    <span className="bw-search-result-name">{p.name}</span>
                    <span className="bw-search-result-meta">{p.origin}</span>
                  </div>
                  <span className="bw-search-result-price">${p.price}</span>
                </div>
              ))}
            </>
          )}
          {lq.length > 0 && results.length === 0 && articles.length === 0 && (
            <div className="bw-search-empty">
              <p style={{ fontFamily: 'var(--serif)', fontSize: 22, marginBottom: 6 }}>No results for "{q}"</p>
              <p style={{ fontSize: 13 }}>Try "yirgacheffe", "espresso", "intensity", or "machine"</p>
            </div>
          )}
          {results.length > 0 && (
            <>
              <div className="bw-search-section-label">{results.length} {results.length === 1 ? 'product' : 'products'}</div>
              {results.map(p => (
                <div key={p.id} className="bw-search-result" onClick={() => pickProduct(p)}>
                  <div className="bw-search-result-img">
                    {p.image
                      ? <img src={p.image} alt={p.name} style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                      : <div className="bw-search-result-img-stripe"></div>
                    }
                  </div>
                  <div className="bw-search-result-info">
                    <span className="bw-search-result-name">{p.name}</span>
                    <span className="bw-search-result-meta">{p.origin}{p.intensity ? ` · Intensity ${p.intensity}` : ''}</span>
                  </div>
                  <span className="bw-search-result-price">${p.price}</span>
                </div>
              ))}
            </>
          )}
          {articles.length > 0 && (
            <>
              <div className="bw-search-section-label">Articles</div>
              {articles.map(a => (
                <div key={a.id} className="bw-search-result" style={{ gridTemplateColumns: '48px 1fr' }}>
                  <div className="bw-search-result-img"><div className="bw-search-result-img-stripe"></div></div>
                  <div className="bw-search-result-info">
                    <span className="bw-search-result-name">{a.title}</span>
                    <span className="bw-search-result-meta">{a.kind} · {a.read}</span>
                  </div>
                </div>
              ))}
            </>
          )}
        </div>
        <div className="bw-search-hint">
          <span>↵ to select · Esc to close</span>
          <span>{results.length + articles.length} results</span>
        </div>
      </div>
    </div>
  );
};

export const Header = ({ page, onNav, cartCount, wishCount, user, onLogin, onSearch }) => {
  const [menuOpen, setMenuOpen] = React.useState(false);

  const links = [
    { key: 'shop', label: 'Shop' },
    { key: 'blog', label: 'Journal' },
    { key: 'contact', label: 'Contact' },
    { key: 'faq', label: 'FAQ' },
  ];

  const go = (target, opts) => {
    setMenuOpen(false);
    onNav(target, opts);
  };

  // Announce bar runs as a looping marquee rather than static text — same
  // duplicated-track technique as the Portfolio page's marquee strip, so
  // the motion language matches across properties. The translateX(-50%)
  // loop only looks seamless if each half of the track is wider than the
  // viewport — Portfolio's strip has six items so that happens by
  // accident, but with just two short phrases here the track ended up
  // narrower than the bar, so it visibly sat confined to the left side
  // instead of spanning it. Repeating the items several times per half
  // guarantees the content overflows regardless of screen width. The
  // second copy of each row is aria-hidden so screen readers only get
  // the message once.
  const topBarItems = ['Free shipping on US orders over $40', 'Roasted to order'];
  const TOP_BAR_REPEATS = 6;
  const topBarRow = (hidden) => (
    <div className="bw-header-top-row" aria-hidden={hidden ? 'true' : undefined}>
      {Array.from({ length: TOP_BAR_REPEATS }).flatMap((_, r) =>
        topBarItems.map((t, i) => (
          <span className="bw-header-top-item" key={`${r}-${i}`}>
            <span className="bw-header-top-dot" aria-hidden="true" />
            {t}
          </span>
        ))
      )}
    </div>
  );

  return (
    <header className="bw-header">
      <div className="bw-header-top">
        <div className="bw-header-top-track">
          {topBarRow(false)}
          {topBarRow(true)}
        </div>
      </div>
      <nav className="bw-nav">
        <button className="bw-menu-toggle" onClick={() => setMenuOpen(o => !o)} aria-label="Menu">
          <Icon name={menuOpen ? 'close' : 'menu'} className="icon" />
        </button>
        <div className="bw-nav-links">
          {links.map(l => (
            <a key={l.key} className={page === l.key ? 'active' : ''} onClick={() => go(l.key)}>{l.label}</a>
          ))}
        </div>
        <div className="bw-logo" onClick={() => go('home')}>
          <span className="bw-logo-mark">B</span>
          <span>Brewed</span>
        </div>
        <div className="bw-nav-actions">
          <button className="bw-icon-btn" onClick={onSearch} aria-label="Search"><Icon name="search" className="icon icon--sm" /></button>
          {user ? (
            <button className="bw-icon-btn" onClick={() => go('account')}><Icon name="user" className="icon icon--sm" /><span className="bw-icon-btn-label">{user.name.split(' ')[0]}</span></button>
          ) : (
            <button className="bw-icon-btn" onClick={onLogin}><Icon name="user" className="icon icon--sm" /><span className="bw-icon-btn-label">Sign in</span></button>
          )}
          <button className="bw-icon-btn" onClick={() => go('wishlist')} aria-label="Wishlist">
            <Icon name="heart" className="icon icon--sm" />
            {wishCount > 0 && <span className="bw-cart-badge" style={{ background: 'var(--ink)' }}>{wishCount}</span>}
          </button>
          <button className="bw-icon-btn" onClick={() => go('cart')} aria-label="Cart">
            <Icon name="bag" className="icon icon--sm" /><span className="bw-icon-btn-label">Cart</span>
            {cartCount > 0 && <span className="bw-cart-badge">{cartCount}</span>}
          </button>
        </div>
      </nav>
      {menuOpen && (
        <div className="bw-mobile-menu">
          {links.map(l => (
            <a key={l.key} className={page === l.key ? 'active' : ''} onClick={() => go(l.key)}>{l.label}</a>
          ))}
        </div>
      )}
    </header>
  );
};

export const Footer = ({ onNav }) => (
  <footer className="bw-footer">
    <div className="bw-footer-top">
      <div className="bw-footer-col bw-footer-brand">
        <div className="bw-logo"><span className="bw-logo-mark">B</span><span>Brewed</span></div>
        <p>Small-batch coffee, roasted in NYC, shipped within 48 hours. Sourced directly from farms we visit, paid above market — every season.</p>
        <form className="bw-footer-news" onSubmit={(e) => e.preventDefault()}>
          <input type="email" placeholder="Your email" />
          <button className="bw-btn bw-btn--primary bw-btn--small" style={{ background: 'var(--cream)', color: 'var(--roast-deep)' }}>Subscribe</button>
        </form>
      </div>
      <div className="bw-footer-col">
        <h4>Shop</h4>
        <a onClick={() => onNav('shop', { type: 'beans' })}>Coffee Beans</a>
        <a onClick={() => onNav('shop', { type: 'pods' })}>Coffee Pods</a>
        <a onClick={() => onNav('shop', { type: 'machines' })}>Machines</a>
        <a onClick={() => onNav('shop', { type: 'gear' })}>Gear</a>
      </div>
      <div className="bw-footer-col">
        <h4>Brewed</h4>
        <a onClick={() => onNav('blog')}>Journal</a>
        <a>Our Story</a><a>Wholesale</a><a>Careers</a>
      </div>
      <div className="bw-footer-col">
        <h4>Help</h4>
        <a onClick={() => onNav('contact')}>Contact</a>
        <a onClick={() => onNav('faq')}>FAQ</a>
        <a>Shipping & Returns</a>
        <a onClick={() => onNav('account')}>Account</a>
      </div>
    </div>
    <div className="bw-footer-bot">
      <span>© 2026 Brewed Roastery · New York, NY</span>
      <span>Made slowly · Served quickly</span>
    </div>
  </footer>
);

export const Toast = ({ msg, shown }) => (
  <div className={`bw-toast ${shown ? 'is-shown' : ''}`}>
    <span className="bw-toast-mark">✓</span>
    <span>{msg}</span>
  </div>
);